import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import {
  FeedbackTypeSchema,
  supportedVendorsSchema,
} from '@eluve/graphql-types';

const c = initContract();

export const llmOutputsContract = c.router(
  {
    importTemplates: {
      method: 'POST',
      path: '/import',
      responses: {
        201: z.object({}),
      },
      body: z.object({
        data: z.array(z.unknown()),
        vendor: supportedVendorsSchema,
        domain: z.string(),
      }),
      summary: 'Import chart templates from EHR',
    },
    addUserFeedbackScore: {
      method: 'POST',
      path: '/:llmOutputId/feedback',
      body: z.object({
        value: FeedbackTypeSchema,
        comment: z.string().optional(),
      }),
      responses: {
        201: z.object({
          scoreId: z.string().uuid(),
        }),
      },
    },
    updateUserFeedbackScore: {
      method: 'PUT',
      path: '/:llmOutputId/feedback/:scoreId',
      body: z.object({
        value: FeedbackTypeSchema,
        comment: z.string().optional(),
      }),
      responses: {
        200: z.object({
          scoreId: z.string().uuid(),
        }),
      },
    },
    addUserFeedbackTagScore: {
      method: 'POST',
      path: '/:llmOutputId/feedback-tag',
      body: z.object({
        value: z.string(),
      }),
      responses: {
        201: z.object({
          scoreId: z.string().uuid(),
        }),
      },
    },
    addUserRatingScore: {
      method: 'POST',
      path: '/:llmOutputId/rating',
      body: z.object({
        value: z.number().min(0).max(10),
        comment: z.string().optional(),
      }),
      responses: {
        201: z.object({
          scoreId: z.string().uuid(),
        }),
      },
    },
  },
  {
    pathPrefix: '/:tenantId/llm-outputs',
  },
);
